type ReturnType = {
  targetUrl: string;
};

export default (
  routeList: string,
  page: number,
  perPage: number,
  sort: string[],
  searchText?: string,
): ReturnType => {
  const params: string [] = [];

  if (searchText) {
    params.push(`searchText=${searchText}`);
  }

  if (sort.length > 1 && sort[0] !== '') {
    params.push(`sort=${sort[0]},${sort[1]}`);
  }

  params.push(`page=${page}`);
  params.push(`perPage=${perPage}`);

  return {
    targetUrl: `${routeList}?${params.join('&')}`,
  };
};
